<script setup lang="ts">
import { computed } from "vue";

import type { Recommendation } from "@reco/shared/src/types/recommendation";

import { getGridboxType } from "@reco/service/src/utils/helpers";
import { getPDPType } from "@reco/service/src/utils/pageType";
import { usePageStore } from "@reco/widgets/src/stores/pageStore";
import { getAdjustedBundleTrackingList } from "@reco/widgets/src/utils";

type GridBoxFragmentProps = {
  product: Recommendation;
  creativeSlot?: string;
  creativeSlotReco?: string;
  recommendationItems?: Recommendation[];
  disableGridboxLink?: boolean;
};

const props = defineProps<GridBoxFragmentProps>();
const { language, country } = usePageStore();

const gridType = computed(() => getGridboxType(country, props.product.list));
const adjustedListId = computed(() => {
  if (!props.recommendationItems) {
    return props.product.list;
  }
  return getAdjustedBundleTrackingList(props.recommendationItems, props.product);
});

const gridData = computed(() => ({
  ...props.product,
  listId: adjustedListId.value,
  listName: adjustedListId.value,
  type: props.product.productType && getPDPType(props.product.productType),
}));

const attrs = computed(() => ({
  "data-grid-data": `[${JSON.stringify(gridData.value)}]`,
  "data-country": country,
  "data-language": language,
  "data-creative-slot": props.creativeSlot ?? undefined,
  "data-creative-slot-reco": props.creativeSlotReco ?? undefined,
  "data-type": gridType.value ?? undefined,
  "data-is-reco-slider": "true",
  "data-disable-gridbox-link": props.disableGridboxLink ? "true" : undefined,
}));
</script>

<template>
  <div data-grid-label="grid-fragment-v2" data-is-slider="true" class="reco-grid-fragment-wrapper" v-bind="attrs"></div>
</template>
